import { api } from './api';

export const goalService = {
    getAllGoalTypes: async () => {
        const response = await api.get('/goals/types');
        return Array.isArray(response.data) ? response.data : [];
    },

    getMemberGoals: async (memberId, year) => {
        const response = await api.get(`/goals/member/${memberId}/${year}`);
        if (!Array.isArray(response.data)) {
            console.error('goalService: Expected array but got:', typeof response.data);
            return [];
        }
        return response.data;
    },

    createGoal: async (goalData) => {
        const response = await api.post('/goals', goalData);
        if (!response.data) {
            console.error('goalService: No response from create goal');
            throw new Error('Failed to create goal');
        }
        return response.data;
    },

    updateGoal: async (goalId, goalData) => {
        const response = await api.put(`/goals/${goalId}`, goalData);
        if (!response.data) {
            throw new Error('Failed to update goal');
        }
        return response.data;
    },

    deleteGoal: async (goalId) => {
        const response = await api.delete(`/goals/${goalId}`);
        return response.data;
    },

    createGoalUpdate: async (goalId, updateData) => {
        const response = await api.post(`/goals/${goalId}/updates`, updateData);
        return response.data;
    },

    getGoalUpdates: async (goalId) => {
        const response = await api.get(`/goals/${goalId}/updates`);
        return response.data;
    },

    getLatestProgress: async (goalId) => {
        try {
            const response = await api.get(`/goals/${goalId}/updates`);
            const updates = response.data;
            if (!updates || updates.length === 0) {
                return null;
            }
            updates.sort((a, b) => new Date(b.update_date) - new Date(a.update_date));
            return updates[0];
        } catch (error) {
            console.error('Error getting latest progress:', error);
            return null;
        }
    }
}; 